// PlayoffEditable.js
import './AdminPlayoff.css';

import React, { useEffect, useState } from 'react';
import { useTournament } from '../TournamentContext';
import axios from 'axios';
import config from '../../config/default.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faMedal, faChampagneGlasses } from '@fortawesome/free-solid-svg-icons';

const base_url = config.base_url;

const PlayoffEditable = () => {
  const [games, setGames] = useState([]);
  const [teams, setTeams] = useState([]);
  const [round4Winner, setRound4Winner] = useState('');
  const [selectedTeams, setSelectedTeams] = useState({});
  const [gameScores, setGameScores] = useState({});
  const { tournamentID } = useTournament();
  const token = localStorage.getItem("token");


  useEffect(() => {
    if (tournamentID) {
      fetchGames();
      fetchTeams();
    }

  }, [tournamentID]);

 const fetchGames = async () => {
  try {
    const response = await axios.get(`${base_url}/api/playoffgames/${tournamentID}`);
    const sortedGames = response.data.sort((a, b) =>
      a.round !== b.round ? a.round - b.round : a.rank - b.rank
    );
    setGames(sortedGames);

    // Set initial selections & scores
    const initialTeams = {};
    const initialScores = {};
    sortedGames.forEach((g) => {
      initialTeams[g._id] = {
        team1: g.team1?._id || null,
        team2: g.team2?._id || null,
      };
      initialScores[g._id] = {
        scoreTeam1: g.scoreTeam1 ?? null, // keep 0 as valid, only null if missing
        scoreTeam2: g.scoreTeam2 ?? null,
      };
    });
    setSelectedTeams(initialTeams);
    setGameScores(initialScores);

    // Final winner
    const round4Game = sortedGames.find((g) => g.round === 4);
    if (round4Game && round4Game.scoreTeam1 !== round4Game.scoreTeam2) {
      if (round4Game.scoreTeam1 > round4Game.scoreTeam2) {
        setRound4Winner(round4Game.team1?.name || 'TBD');
      } else {
        setRound4Winner(round4Game.team2?.name || 'TBD');
      }
    } else {
      setRound4Winner('TBD');
    }
  } catch (err) {
    console.error('Failed to fetch games', err);
  }
};


  const fetchTeams = async () => {
    try {
      const res = await axios.get(`${base_url}/api/teams/${tournamentID}`);
      setTeams(res.data);
    } catch (err) {
      console.error('Failed to fetch teams', err);
    }
  };

  const handleTeamSelect = (gameId, teamNum, teamId) => {
    setSelectedTeams((prev) => ({
      ...prev,
      [gameId]: {
        ...prev[gameId],
        [`team${teamNum}`]: teamId,
      },
    }));
  };

  const handleScoreChange = (e, gameId, teamNum) => {
    setGameScores((prev) => ({
      ...prev,
      [gameId]: {
        ...prev[gameId],
        [`scoreTeam${teamNum}`]: e.target.value,
      },
    }));
  };

 

const updateAllGames = async () => {
  try {
    const changedGames = games.filter((game) => hasUnsavedChanges(game));

    await Promise.all(
      changedGames.map(async (game) => {
        const updates = {};
        const scoreUpdates = gameScores[game._id] || {};
        const teamUpdates = selectedTeams[game._id] || {};

        if (teamUpdates.team1) {
          updates.team1 = teamUpdates.team1;
        }
        if (teamUpdates.team2) {
          updates.team2 = teamUpdates.team2;
        }
        if (scoreUpdates.scoreTeam1 !== null && scoreUpdates.scoreTeam1 !== undefined) {
          updates.scoreTeam1 = Number(scoreUpdates.scoreTeam1);
        }
        if (scoreUpdates.scoreTeam2 !== null && scoreUpdates.scoreTeam2 !== undefined) {
          updates.scoreTeam2 = Number(scoreUpdates.scoreTeam2);
        }

        if (Object.keys(updates).length > 0) {
          await axios.put(
            `${base_url}/api/${tournamentID}/playoffgames/${game._id}`,
            updates,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }
      })
    );

     fetchGames();
         
 
    alert("Games updated successfully!");
  } catch (err) {
    console.error("Failed to update games", err);
  }
};

 const sortedTeams = teams.sort((a, b) => {
    if (a.standing === 0 && b.standing !== 0) return 1;   // push a down
    if (b.standing === 0 && a.standing !== 0) return -1;  // push b down
    return a.standing - b.standing; // normal ascending 
  });

  const createPlayoffGames = async () => {

    try {
     const response = await axios.delete(base_url+`/api/playoffgames/`+tournamentID, {headers: { Authorization: `Bearer ${token}` } });
     
   } catch (error) {
     console.error('Failed to delete playoff games', error);

   }
   const teamsToPlay = sortedTeams.slice(0, 16);
console.log('Teams to play:', teamsToPlay);
       
   if (teamsToPlay.length > 1) {
     const games = [];
     const rankaound1 = [1,8,6,4,3,5,7,2];
     const roundrank = [
       [2,1],
       [2,2],
       [2,3],
       [2,4],
       [3,1],
       [3,2],
       [4,1]
     ]

     for (let i = 0; i < teamsToPlay.length/2; i++) {
       const teamA = teamsToPlay[i];
       const teamB = teamsToPlay[teamsToPlay.length - i - 1];
       const rank = rankaound1[i];
 
       try {
         const response = await axios.post(base_url + `/api/playoffgames/`+tournamentID, {
           team1: teamA,
           team2: teamB,
           isWildCard: false,
           round: 1,
           rank: rank,
         }, { headers: { Authorization: `Bearer ${token}` } });
        
         games.push(response.data);
 
       } catch (error) {
         console.error('Failed to create round 1 games', error);
       }
     }

     for (const [round, rank] of roundrank) {
       try {
         await axios.post(base_url + `/api/playoffgames/`+tournamentID, {
           round: round,
           rank: rank,
         }, { headers: { Authorization: `Bearer ${token}` } });
       } catch (error) {
         console.error('Failed to create games', error);
       }
     }
    
   }
   fetchGames();
   alert('Playoff Games added successfully!');
   
 };

const hasUnsavedChanges = (game) => {
  const origTeam1 = game.team1?._id || null;
  const origTeam2 = game.team2?._id || null;
  const origScore1 = game.scoreTeam1 ?? null;
  const origScore2 = game.scoreTeam2 ?? null;

  const curTeams = selectedTeams[game._id] || {};
  const curScores = gameScores[game._id] || {};

  return (
    curTeams.team1 !== origTeam1 ||
    curTeams.team2 !== origTeam2 ||
    Number(curScores.scoreTeam1) !== origScore1 ||
    Number(curScores.scoreTeam2) !== origScore2
  );
};



  return (
    <div>
      <br />
      <div className="admin-container">
  <br />
  <div className="admin-bracket">
    <h2>Manage Playoff Bracket</h2>
    {/* ... */}
    <div className="admin-tournament">
      {Array.from({ length: 4 }, (_, roundIndex) => (
        <div key={`round-${roundIndex + 1}`}>
          {games
            .filter((game) => game.round === roundIndex + 1)
            .map((game) => (
              <ul
                key={`round-${roundIndex + 1}-${game.rank}`}
                className={`admin-round admin-round-${roundIndex + 1} ${
                  hasUnsavedChanges(game) ? 'unsaved' : ''
                }`}
              >
                <li className="admin-spacer">&nbsp;</li>

                {/* TEAM 1 */}
                <li className={`admin-game admin-game-top ${game.scoreTeam1 > game.scoreTeam2 ? 'winner' : ''}`}>
                  <select
                    value={selectedTeams[game._id]?.team1 || ''}
                    onChange={(e) => handleTeamSelect(game._id, 1, e.target.value)}
                  >
                    <option value="">-- Team 1 --</option>
                    {teams.map((t) => (
                      <option key={t._id} value={t._id}>{t.name}</option>
                    ))}
                  </select>
                  <input
                    type="number"
                    value={gameScores[game._id]?.scoreTeam1 || ''}
                    onChange={(e) => handleScoreChange(e, game._id, 1)}
                    onWheel={(e) => e.currentTarget.blur()}
                    className="score-input"
                  />
                </li>

                <li className="admin-game admin-game-spacer">&nbsp;</li>

                {/* TEAM 2 */}
                <li className={`admin-game admin-game-bottom ${game.scoreTeam2 > game.scoreTeam1 ? 'winner' : ''}`}>
                  <select
                    value={selectedTeams[game._id]?.team2 || ''}
                    onChange={(e) => handleTeamSelect(game._id, 2, e.target.value)}
                  >
                    <option value="">-- Team 2 --</option>
                    {teams.map((t) => (
                      <option key={t._id} value={t._id}>{t.name}</option>
                    ))}
                  </select>
                  <input
                    type="number"
                    value={gameScores[game._id]?.scoreTeam2 || ''}
                    onChange={(e) => handleScoreChange(e, game._id, 2)}
                    onWheel={(e) => e.currentTarget.blur()}
                    className="score-input"
                  />
                </li>
              </ul>
            ))}
        </div>
      ))}
    </div>

    <button onClick={updateAllGames} className="update-btn">
      Save Changes
    </button>
  </div>
</div>

    </div>
  );
};

export default PlayoffEditable;
